import { render, staticRenderFns } from "./FormulaEditor.vue?vue&type=template&id=2ea33f63&scoped=true"
import script from "./FormulaEditor.vue?vue&type=script&lang=js"
export * from "./FormulaEditor.vue?vue&type=script&lang=js"
import style0 from "./FormulaEditor.vue?vue&type=style&index=0&id=2ea33f63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea33f63",
  null
  
)

export default component.exports